// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- RxJs
import { Observable, BehaviorSubject } from 'rxjs';
import { SimpleStringWrapper } from 'src/app/models/shared/utility/simple-string-wrapper';

// #endregion

@Injectable({
  providedIn: 'root'
})
export abstract class ActivationBaseService {
  protected _token$: BehaviorSubject<string>;
  get token$(): Observable<string> {
    return this._token$;
  }

  protected _emailAddress$: BehaviorSubject<string>;
  get emailAddress$(): Observable<string> {
    return this._emailAddress$;
  }

  protected _otac$: BehaviorSubject<string>;
  get otac$(): Observable<string> {
    return this._otac$;
  }

  constructor() {
    this._token$ = new BehaviorSubject<string>(null);
    this._emailAddress$ = new BehaviorSubject<string>(null);
    this._otac$ = new BehaviorSubject<string>(null);
  }

  abstract resolveToken(token: string): void;
  abstract activateAccount(token: string): Observable<SimpleStringWrapper>;
}
